import axios from "axios";
import { Config } from "../../../../../core/config/config";
import { processLoadOptions } from "../../../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/product/admin/product`;

export const productService = {
    getProducts: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-products`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },

    getProductAccounts: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/product-accounts`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },

    approveProducts: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/approve-products`, params)
        .then((response) => {
            return response.data;
        });
    },
    rejectProducts: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/reject-products`, params)
        .then((response) => {
            return response.data;
        });
    },
}
